export default {
    'preview.download.pdf': '下载PDF'

};
